import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, Events } from 'ionic-angular';
import { environment } from '../../environments/environment';
import { LoginProvider } from '../../providers/login/login';
import { SettingsProvider  } from '../../providers/settings/settings';
import { ToastProvider } from '../../providers/toast/toast';
import { TranslateService } from '@ngx-translate/core';



@IonicPage()
@Component({
  selector: 'page-settings',
  templateUrl: 'settings.html',
})
export class SettingsPage {

  userinfo: any;
  away: boolean;
  notifications: Notifications[];
  permissions: any;
  ivr = {
    ivr_p: null,
    ivr_s: null,
    ivr_enable: false
  };
  languages  : any;
  keys = []
  officeName: any
  dispAppName : any
  settingNotifyObj : any
  lang: any;
  selRegistrationLogin : any
  

  constructor(public navCtrl: NavController, 
    public navParams: NavParams, 
    private translate: TranslateService,
    private loginProvider: LoginProvider, 
    private settingsProvider: SettingsProvider,
    private toast: ToastProvider,
    private events: Events) {
      

this.officeName = environment.officeName
this.dispAppName = environment.dispAppName
this.settingNotifyObj =  {officeName:this.officeName,dispAppName:this.dispAppName}
this.languages = environment.languages;
console.log(this.languages)
this.keys = Object.keys(this.languages);
console.log(this.keys)
this.lang = this.translate.currentLang;
// console.log()

this.selRegistrationLogin = localStorage.getItem('signup_login')

if(this.selRegistrationLogin){
  // this.toast.presentToast("You are Unauthorized to use this feature , Please request to admin.");
}
else{
    loginProvider.getUserDetails().then(val => {
      this.permissions = val.permissions;
    });
    settingsProvider.getUserDetails().then(val => {
      this.away = (val.home_away)? true: false;
      this.userinfo = val;
      this.setIVR();
    });
    settingsProvider.getNotificationStatus().then(val => {
      this.notifications = val.data;
    });
  }
  }

  setLanguage(lang: string){
    this.settingsProvider.setLanguage(lang);
    localStorage.setItem('lang', lang);   
    if(environment.debug) console.log("Selected language => ", lang);    
  }  
  setIVR(){
    this.ivr = {
      ivr_p: this.userinfo.ivr_p,
      ivr_s: this.userinfo.ivr_s,
      ivr_enable: (this.userinfo.ivr_enable == 0)?false:true
    }
  }

  onIVRChange(){
    this.ivr.ivr_enable = !this.ivr.ivr_enable;
  }

  updateIVR(){

if(this.selRegistrationLogin){
   this.toast.presentToast("You are Unauthorized to use this feature , Please request to admin.");
}
else{
    
    if(this.validateIVR()){
      let updatedUserInfo = this.userinfo;
      updatedUserInfo.ivr_enable = (this.ivr.ivr_enable)?1:0;
      updatedUserInfo.ivr_p = this.ivr.ivr_p;
      updatedUserInfo.ivr_s = this.ivr.ivr_s;
      this.settingsProvider.updateUserInfo(updatedUserInfo).then(val => {
        if(val.status == "success"){
          this.toast.presentToast(val.message);
          this.settingsProvider.getUserDetails().then(val => {
            this.userinfo = val;
            this.setIVR();
          });
        }else {
       
          this.setIVR();
        }
      }).catch(err => {
    
        this.setIVR();
      });
    }   
  }
  }

  validateIVR(){
    var patt = new RegExp('^[0-9]+$');
    if(this.ivr.ivr_p && (String(this.ivr.ivr_p).length < 9 || String(this.ivr.ivr_p).length > 12 || !patt.test(String(this.ivr.ivr_p)))){
      this.toast.presentToast("Please enter a valid primary ivr number");
      return false;
    }else if(this.ivr.ivr_s && (String(this.ivr.ivr_s).length < 9 || String(this.ivr.ivr_s).length > 12 || !patt.test(String(this.ivr.ivr_s)))){
      this.toast.presentToast("Please enter a valid secondary ivr number");
      return false;
    }else{
      return true;
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SettingsPage');
  }

  onAwayChange(){
    this.away = !this.away;
    this.userinfo.home_away = (this.away)?1:0;
    this.settingsProvider.updateUserInfo(this.userinfo).then(val => {
      if(val.status == "success"){
        this.events.publish('homeAwayUpdate', this.away);
        this.toast.presentToast(val.message);
      }else {
        this.away = !this.away;
      }
    }).catch(err => {
      this.away = !this.away;
    });
  }

  onItemChange(item){
    item.switch = !item.switch;
    this.settingsProvider.setNotificationStatus(item.name, item.switch).then(val => {
      if(val.status == "success"){
        this.toast.presentToast(val.message);
      }else {
        item.switch = !item.switch; 
      }
    }).catch(err => {
      item.switch = !item.switch;
    });
  }

}

interface Notifications {
  name: string;
  switch: number;
}



// WEBPACK FOOTER //
// ./src/pages/settings/settings.ts